<template>
  <div class="container">
    <el-form v-model="form"
      :inline="true"
      ref="filtrateForm"
      size="mini">
      <el-form-item label="订单ID:">
        <el-select v-model="order_out_type"
          size="mini"
          @change="selectOrderType">
          <el-option label="外部订单号"
            value="1"></el-option>
          <el-option label="内部订单号"
            value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input size="mini"
          v-if="order_out_type == 1"
          v-model="form.out_order_no"
          style="width:160px;"
          placeholder="输入订单号搜索">
        </el-input>
        <el-input size="mini"
          v-if="order_out_type == 2"
          v-model="form.order_no"
          style="width:160px;"
          placeholder="输入订单号搜索"></el-input>
        <el-input size="mini"
          v-if="order_out_type != 2 && order_out_type != 1"
          placeholder="输入订单号搜索"
          style="width:160px;"></el-input>
      </el-form-item>

      <el-form-item label="来源:">
        <el-select style="width:180px;"
          v-model="form.supply_id">
          <el-option label="全部"
            value></el-option>
          <el-option v-for="(item, index) in sourceList"
            :key="index"
            :label="item.name"
            :value="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="对接方式:">
        <el-select v-model="form.supply_channel_type">
          <el-option label="全部"
            value="0"></el-option>
          <el-option label="1688接入"
            value="1"></el-option>
          <el-option label="供应商接入"
            value="2"></el-option>
          <el-option label="自营创建"
            value="0"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="维权时间:">
        <el-row>
          <el-col :span="18">
            <el-date-picker v-model="selectedTime"
              type="daterange"
              align="right"
              unlink-panels
              format="yyyy-MM-dd"
              range-separator="~"
              start-placeholder="起始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="timeOptions"></el-date-picker>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item label="商品名称:"
        style="float:left;">
        <el-input size="mini"
          placeholder="请输入商品名称搜索"
          style="width:240px;"
          v-model="form.keywords"></el-input>
      </el-form-item>

      <el-form-item style="float:left;">
        <el-button type="primary"
          @click="pageChange(1)">查询</el-button>
        <el-button @click="resetForm('filtrateForm')">重置</el-button>
        <el-button type="warning"
          @click="exportOrderData">导出</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData"
      max-height="600"
      size="mini"
      style="width: 100%"
      :cell-style="tc"
      :header-cell-style="tccolor"
      ref="table">
      <el-table-column label="订单ID"
        prop="order_no"
        width="160"></el-table-column>
      <el-table-column label="渠道订单ID"
        prop="out_order_no"
        width="140"></el-table-column>
      <el-table-column label="来源">
        <template slot-scope="scope">
          <p v-if="scope.row.supply_name">
            {{ scope.row.supply_name }}
          </p>
          <p v-else>---</p>
        </template>
      </el-table-column>
      <el-table-column label="对接方式">
        <template slot-scope="scope">
          <p v-if="scope.row.supply_channel_type == 0">自营创建</p>
          <p v-if="scope.row.supply_channel_type == 1">1688接入</p>
          <p v-if="scope.row.supply_channel_type == 2">供应商接入</p>
        </template>
      </el-table-column>
      <el-table-column label="商品图">
        <template slot-scope="scope">
          <img style="width:36px;height:36px;"
            :src="scope.row.img_url" />
        </template>
      </el-table-column>
      <el-table-column label="商品名称"
        prop="title"
        width="210"></el-table-column>
      <el-table-column label="商品分类">
        <template slot-scope="scope">
          <p v-if="scope.row.cate_name">
            {{ scope.row.cate_name }}
          </p>
          <p v-else>---</p>
        </template>
      </el-table-column>
      <el-table-column label="订单状态">
        <template slot-scope="scope">
          <p v-if="scope.row.order_status == 0">
            <span class="account_status_zhifu">●</span>待支付
          </p>
          <p v-if="scope.row.order_status == 1">
            <span class="account_status_fahuo">●</span>待发货
          </p>
          <p v-if="scope.row.order_status == 2">
            <span class="account_status_fahuo">●</span>已发货
          </p>
          <p v-if="scope.row.order_status == 6">
            <span class="account_status_shouhuo">●</span>已签收
          </p>
          <p v-if="scope.row.order_status == 7">
            <span class="account_status_shouhuo">●</span>已收获
          </p>
          <p v-if="scope.row.order_status == 3">
            <span class="account_status_wancheng">●</span>已取消
          </p>
          <p v-if="scope.row.order_status == 4">
            <span class="account_status_wancheng">●</span>已完成
          </p>
          <p v-if="scope.row.order_status == 5">
            <span class="account_status_guanbi">●</span>已关闭
          </p>
        </template>
      </el-table-column>
      <el-table-column label="维权状态">
        <template slot-scope="scope">
          <p v-if="scope.row.status == 0">无</p>
          <p v-if="scope.row.status == 1">待审核</p>
          <p v-if="scope.row.status == 2">处理中</p>
          <p v-if="scope.row.status == 3">处理完成</p>
          <p v-if="scope.row.status == 4">已拒绝</p>
        </template>
      </el-table-column>

      <el-table-column label="订单金额">
        <template slot-scope="scope">
          <!-- <div v-if="scope.row.order_pay"> -->
          <p v-if="scope.row.money_pay">¥ {{ scope.row.money_pay }}</p>
          <p v-else>---</p>
          <!-- </div> -->
          <!-- <div v-else>---</div> -->
        </template>
      </el-table-column>
      <el-table-column label="维权发起时间"
        prop="created_at"
        sortable="created_at"
        width="140"></el-table-column>
      <el-table-column label="操作"
        fixed="right"
        width="160">
        <template slot-scope="scope">
          <el-button type="warning"
            size="mini"
            @click="gotoOrderDetail(scope.row.id)">详情</el-button>
          <el-button type="danger"
            size="mini"
            @click="watchOrderDialog(scope.row.id)">备注</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="pageChange"
        :current-page="form.page"
        :page-sizes="[20, 50, 100]"
        :page-size="form.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <gydialog title="维权备注"
      :visible.sync="showOrderDialog"
      width="640px">
      <div style="padding:18px 24px">
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in activities"
            :key="index"
            :icon="activity.icon"
            :type="activity.type"
            :color="activity.color"
            :size="activity.size">
            <div class="timeline-content">{{ activity.content }}</div>
            <div class="timeline-content">{{ activity.timestamp }}</div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </gydialog>
  </div>
</template>

<script>
import { supplyChannel } from '@/api/goods'
import { parseTime } from '@/utils/index'
import { safeguardOrderList, afterSaleRemarksList, exportOrderAferSale } from '@/api/order'
import { BASE_API } from '@/config'
export default {
  data () {
    return {
      order_out_type: '',
      form: {
        page: 1,
        size: 20,
        order_no: '',
        out_order_no: '',
        supply_id: '',
        supply_channel_type: '0',
        create_start_time: '',
        create_end_time: '',
        keywords: ''
        // orderBys: ''
      },
      selectedTime: '',
      timeOptions: {
        shortcuts: [
          {
            text: '最近一天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近15天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(new Date().setMonth(new Date().getMonth() - 1))
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      //来源数据
      sourceList: [],
      tableData: [],
      total: 0,
      showOrderDialog: false,
      currentId: '',
      activities: []
    }
  },
  activated () {
    this.supplyChannelListData()
    this.getList()
  },
  methods: {
    //导出维权订单
    exportOrderData () {
      exportOrderAferSale(this.form).then(res => {
        window.open(`${BASE_API}/admin/download/zip/${res.download_token}`)
      })
    },
    pageChange (page) {
      this.form.page = page
      this.getList()
    },
    //查看备注
    watchOrderDialog (id) {
      this.currentId = id
      this.afterSaleRemarksListData()
    },
    selectOrderType (id) {
      if (id == 1) {
        this.form.order_no = ''
      } else {
        this.form.out_order_no = ''
      }
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.selectedTime = ''
      this.order_out_type = ''
      this.form = {
        page: this.form.page,
        size: this.form.size,
        order_no: '',
        out_order_no: '',
        supply_id: '',
        supply_channel_type: '0',
        create_start_time: '',
        create_end_time: '',
        keywords: ''
      }
    },
    handleSizeChange (val) {
      this.form.size = val
      this.pageChange(1)
    },
    async getList () {
      const form = this.form
      if (this.selectedTime !== '') {
        form.create_start_time = parseTime(
          this.selectedTime[0],
          'yyyy-MM-dd hh:mm:ss'
        )
        form.create_end_time = parseTime(
          this.selectedTime[1],
          'yyyy-MM-dd hh:mm:ss'
        )
      }
      let res = await safeguardOrderList(this.form)
      this.tableData = res.data
      this.total = res.total
    },
    //维权订单备注列表
    async afterSaleRemarksListData () {
      let res = await afterSaleRemarksList(this.currentId)

      if (res.length > 0) {
        res.map(item => {
          this.activities.push({
            timestamp: item.created_at,
            content: item.remark
          })
        })
        this.showOrderDialog = true
      } else {
        this.$message.error('该订单无备注')
      }
    },

    //查看详情
    gotoOrderDetail (id) {
      this.$router.push({
        path: './guardDetail',
        query: {
          orderId: id
        }
      })
    },
    //获取商品来源
    async supplyChannelListData () {
      let res = await supplyChannel({ name: '', page: 1, size: 100 })
      this.sourceList = res.data
    },
    tc () {
      return 'text-align:center;'
    },
    tccolor () {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
	padding: 20px;
	.account_status_wancheng {
		color: #67c23a;
	}
	//已关闭
	.account_status_guanbi {
		color: #f4222d;
	}
	//待支付
	.account_status_zhifu {
		color: rgb(191, 191, 191);
	}
	//待发货
	.account_status_fahuo {
		color: rgb(253, 190, 44);
	}
	//待收获
	.account_status_shouhuo {
		color: rgb(26, 121, 206);
	}
	.pagination {
		float: right;
		margin-top: 20px;
	}
	.el-timeline-item {
		text-align: left;
	}

	.timeline-content {
		color: #999;
		font-size: 12px;
		margin-bottom: 4px;
	}
}
</style>
